import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import commonFormMeta from '@Shared/components/form/commonFormMeta';

export interface IProfileApplicationMeta{
  idBank: FormInputMeta,
  nameBank: FormInputMeta,
  idProfile: FormInputMeta,
  nameProfile: FormInputMeta,
  candidate: FormInputMeta, 
  coCandidate: FormInputMeta,
  candidateAddress: FormInputMeta,
  correspondanceAddress: FormInputMeta,
  language: FormInputMeta,
  equityAndIncome: FormInputMeta,
  currentDebt: FormInputMeta,
  warantyType: FormInputMeta,
  requiredDocuments: FormInputMeta,
  prepaidAccount: FormInputMeta,
  debitAccount: FormInputMeta,
  creditAccount: FormInputMeta,
  card: FormInputMeta,
  

  schema: any,
}

const ProfileApplicationMeta: IProfileApplicationMeta= {} as IProfileApplicationMeta;

ProfileApplicationMeta.idBank = commonFormMeta.idBank;
ProfileApplicationMeta.nameBank = commonFormMeta.nameBank;

ProfileApplicationMeta.idProfile = {
  name: 'idProfile',
  type: 'text',
  label: 'ID Profil',
  placeholder: '',
  validation: yup.string().required(),
};

ProfileApplicationMeta.nameProfile = {
  name: 'nameProfile',
  type: 'text',
  label: 'Nom Profil',
  placeholder: '',
  validation: yup.string().required(),
};

ProfileApplicationMeta.candidate = {
  name: "candidate",
  type: "checkbox",
  label: "Candidat",
  validation: yup.boolean()
};
ProfileApplicationMeta.coCandidate = {
  name: "coCandidate",
  type: "checkbox",
  label: "Co-candidat",
  validation: yup.boolean()
};
ProfileApplicationMeta.candidateAddress = {
  name: "candidateAddress",
  type: "checkbox",
  label: "Adresse Candidat",
  validation: yup.boolean()
};
ProfileApplicationMeta.correspondanceAddress = {
  name: "correspondanceAddress",
  type: "checkbox",
  label: "Adresse correspondance",
  validation: yup.boolean()
};

ProfileApplicationMeta.language = {
  name: "language",  
  type: "checkbox",
  label: "Langue",
  validation: yup.boolean(),
};
ProfileApplicationMeta.equityAndIncome = {
  name: "equityAndIncome",  
  type: "checkbox",
  label: "Capital propre et revenu",
  validation: yup.boolean(),
};
ProfileApplicationMeta.currentDebt = {
  name: "currentDebt",  
  type: "checkbox",
  label: "Dette en cours",
  validation: yup.boolean(),
};
ProfileApplicationMeta.warantyType = {
  name: "warantyType",  
  type: "checkbox",
  label: "Type garantie",
  validation: yup.boolean(),
};
ProfileApplicationMeta.requiredDocuments = {
  name: "requiredDocuments",  
  type: "checkbox",
  label: "Documents requis",
  validation: yup.boolean(),
};
ProfileApplicationMeta.prepaidAccount = {
  name: "prepaidAccount",  
  type: "checkbox",
  label: "Compte prépayé",
  validation: yup.boolean(),
};
ProfileApplicationMeta.debitAccount = {
  name: "debitAccount",  
  type: "checkbox",
  label: "Compte debit",
  validation: yup.boolean(),
};
ProfileApplicationMeta.creditAccount = {
  name: "creditAccount",  
  type: "checkbox",
  label: "Compte credit",
  validation: yup.boolean(),
};
ProfileApplicationMeta.card = {
  name: "card",  
  type: "checkbox",
  label: "Carte",
  validation: yup.boolean(),
};



const validationSchema: any = {};

for (let fieldname in ProfileApplicationMeta) {
  validationSchema[fieldname] = (ProfileApplicationMeta as any)[fieldname].validation;
}

ProfileApplicationMeta.schema = yup.object().shape(validationSchema);

export default ProfileApplicationMeta;

